import { httpOk, GET } from 'helpers/api'

/**
 * Доступ к страницам меню кабинета.
 *
 * Меню владельца приходит с бэка уже без закрытых пунктов, но маршрут открывался
 * любому, кто знает ссылку: и сотруднику по прямому заходу, и после переключения
 * на связанный аккаунт без права. Список `{ url, allowed }` по всем пунктам меню
 * отдаёт `GET /users/navigation-access` — правило то же, что у самого меню.
 *
 * Запрос один на токен: при смене аккаунта страница перезагружается, при входе
 * под другим логином меняется токен — и список запрашивается заново.
 */
let cache = { token: null, promise: null, data: null }

function normalizePath(url) {
	const path = String(url || '').split('?')[0]
	if (!path) return ''
	return path.startsWith('/') ? path : '/' + path
}

export function loadedNavigationAccess() {
	const token = localStorage.getItem('token')
	return cache.token === token ? cache.data : null
}

export function loadNavigationAccess() {
	const token = localStorage.getItem('token')
	if (cache.token === token && cache.promise) return cache.promise

	const promise = GET('/users/navigation-access', {}, { notification: false }).then(response => {
		// Сбой запроса не должен запирать кабинет: сервер всё равно проверяет права сам
		const data = httpOk(response) ? (response.data.data || []) : []
		if (cache.promise === promise) cache.data = data
		return data
	})

	cache = { token, promise, data: null }
	return promise
}

/**
 * Открыт ли путь. Путь вне меню (карточки, формы, помощь) не трогаем; из пунктов
 * меню побеждает самый длинный совпавший url — /finance/accounts/5/transactions
 * решает пункт /finance/accounts. Пункты одного пути с разными query (/products?...)
 * считаются вместе: открыт хотя бы один — открыт путь.
 */
export function isPathAllowed(pathname, access) {
	let matched = ''
	let allowed = true

	for (let i = 0; i < access.length; i++) {
		const path = normalizePath(access[i].url)
		if (!path || path.length < matched.length) continue
		if (pathname !== path && pathname.indexOf(path + '/') !== 0) continue

		if (path.length > matched.length) {
			matched = path
			allowed = !!access[i].allowed
		} else if (access[i].allowed) {
			allowed = true
		}
	}

	return allowed
}

/** Куда увести с закрытой страницы: домашняя роли, если открыта, иначе первый открытый пункт меню. */
export function allowedFallbackPath(homePath, access) {
	if (isPathAllowed(homePath, access)) return homePath

	const item = access.find(row => row.allowed && normalizePath(row.url))
	return item ? normalizePath(item.url) : '/hello'
}
